
document.addEventListener("DOMContentLoaded", function () {
  const cartIcon = document.getElementById("cartIcon");
  const cartDrawer = document.getElementById("CartDrawer");
  const cartOverlay = document.getElementById("CartDrawerOverlay");
  const cartClose = document.getElementById("CartDrawerClose");
  const cartLoader = document.getElementById("CartDrawerLoader");

function formatCurrency(cents) {
  const amount = cents / 100;
  // Agar Shopify ka dynamic multi-currency format available hai toh usse chalaye, varna fallback format kare
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
    const activeCurrency = window.Shopify.currency.active;
    const locale = activeCurrency === 'INR' ? 'en-IN' : 'en-US';
    return amount.toLocaleString(locale, {
      style: 'currency',
      currency: activeCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  // Fallback (Agar kuch load na ho toh default $)
  return '$' + amount.toFixed(2);
}

  function showLoader() {
    if (cartLoader) cartLoader.classList.add("is-loading");
  }

  function hideLoader() {
    if (cartLoader) cartLoader.classList.remove("is-loading");
  }

  function openCartDrawer() {
    updateCartDrawer();
    if(cartDrawer && cartOverlay) {
      cartDrawer.classList.add("is-open");
      cartOverlay.classList.add("is-open");
      cartDrawer.setAttribute("aria-hidden", "false");
    }
  }

  function closeCartDrawer() {
    if(cartDrawer && cartOverlay) {
      cartDrawer.classList.remove("is-open");
      cartOverlay.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
    }
  }

  if (cartIcon) {
    cartIcon.addEventListener("click", function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartClose) cartClose.addEventListener("click", closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener("click", closeCartDrawer);

 function updateCartDrawer() {
    showLoader();
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const cartCountBadge = document.getElementById("CartCount");
       if (cartCountBadge) {
  if (cart.item_count > 0) {
    cartCountBadge.textContent = cart.item_count;
    cartCountBadge.style.display = "flex";
  } else {
    cartCountBadge.style.display = "none";
  }
}

        const itemsContainer = document.getElementById("CartDrawerItems");
        const emptyContainer = document.getElementById("CartDrawerEmpty");
        const footerContainer = document.getElementById("CartDrawerFooter");
        const totalContainer = document.getElementById("CartDrawerTotal");

        if (!itemsContainer || !totalContainer) return;

totalContainer.textContent = formatCurrency(cart.total_price);

        if (cart.item_count === 0) {
          itemsContainer.style.display = "none";
          if (footerContainer) footerContainer.style.display = "none";
          
          if (emptyContainer) emptyContainer.style.display = "block";
          
          hideLoader();
          return;
        } else {
          itemsContainer.style.display = "block";
          if (footerContainer) footerContainer.style.display = "block";
          
  
          if (emptyContainer) emptyContainer.style.display = "none";
        }

        let itemsHtml = "";
        cart.items.forEach((item, index) => {
          const lineIndex = index + 1;
          itemsHtml += `
            <div class="drawer-item" data-line="${lineIndex}">
              <img src="${item.image ? item.image : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'}" alt="${item.title}">
              
              <div class="drawer-item-details">
                <div class="drawer-item-meta">
                  <div class="drawer-item-title">${item.product_title}</div>
                  ${item.variant_title ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ""}
                </div>

                <div class="drawer-item-actions">
                  <div class="drawer-qty-selector">
                    <button type="button" class="qty-btn-cart minus-qty" data-line="${lineIndex}" data-qty="${item.quantity}">-</button>
                    <input type="text" value="${item.quantity}" class="qty-input-cart" readonly>
                    <button type="button" class="qty-btn-cart plus-qty" data-line="${lineIndex}" data-qty="${item.quantity}">+</button>
                  </div>
                <div class="drawer-item-price">${item.quantity} × ${formatCurrency(item.final_price)}</div>
                </div>
              </div>

              <button type="button" class="drawer-item-remove" data-line="${lineIndex}" aria-label="Remove item">
             <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          `;
        });
        
        itemsContainer.innerHTML = itemsHtml;
        setupDrawerActionListeners(); 
        hideLoader();
      })
      .catch((err) => {
        console.error("Error fetching cart:", err);
        hideLoader();
      });
  }

  function setupDrawerActionListeners() {

    document.querySelectorAll(".minus-qty").forEach(btn => {
      btn.addEventListener("click", function() {
        const line = this.getAttribute("data-line");
        const currentQty = parseInt(this.getAttribute("data-qty"));
        changeQuantity(line, currentQty - 1);
      });
    });

   
    document.querySelectorAll(".plus-qty").forEach(btn => {
      btn.addEventListener("click", function() {
        const line = this.getAttribute("data-line");
        const currentQty = parseInt(this.getAttribute("data-qty"));
        changeQuantity(line, currentQty + 1);
      });
    });

  
    document.querySelectorAll(".drawer-item-remove").forEach(btn => {
      btn.addEventListener("click", function() {
        const line = this.getAttribute("data-line");
        changeQuantity(line, 0);
      });
    });
  }

  function changeQuantity(line, newQty) {
    showLoader();
    
    const data = {
      line: parseInt(line),
      quantity: parseInt(newQty)
    };

    fetch("/cart/change.js", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(() => {
      updateCartDrawer(); 
    })
    .catch(err => {
      console.error("Error modifying quantity:", err);
      hideLoader();
    });
  }


  document.addEventListener("cart:item-added", function () {
    openCartDrawer();
  });
});